<template>
  <div>
    <a
      v-for="(component, index) in followSvgComponents"
      :key="index"
      :href="component.url"
      target="_blank"
    >
      <component v-bind:is="component.svg" :key="index" class="image-footer mr-3"></component>
    </a>
  </div>
</template>
<script>
import SVGFacebook from "@/static/social/facebook.svg";
import SVGTwitter from "@/static/social/twitter.svg";
import SVGInstagram from "@/static/social/instagram.svg";
import SVGYoutube from "@/static/social/youtube.svg";
import SVGTikTok from "@/static/social/tiktok.svg";

export default {
  name: "social-icons",
  components: {
    SVGFacebook,
    SVGTwitter,
    SVGInstagram,
    SVGYoutube,
    SVGTikTok,
  },
  data() {
    return {
      followSvgComponents: [
        {
          svg: "SVGFacebook",
          url: "https://www.facebook.com/GlobalStorePH/",
        },
        {
          svg: "SVGTwitter",
          url: "https://twitter.com/@GlobalStore_PH",
        },
        {
          svg: "SVGInstagram",
          url: "https://www.instagram.com/GlobalStorePH/",
        },
        {
          svg: "SVGYoutube",
          url: "https://www.youtube.com/channel/UCELAJqSDehOVSMwCtupU4rg",
        },
        {
          svg: "SVGTikTok",
          url: "https://www.tiktok.com/@globalstoreph",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">

.image-footer {
  height: 40px;
  width: 40px;
}
</style>
